import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatIconModule
  ],
  templateUrl: './register.component.html',
  styleUrl: './register.component.css'
})
export class RegisterComponent implements OnInit {
  private readonly registerEndpoint = `${environment.backend.baseUrl}${environment.backend.apiUrl}/Register/register-invite`;
  nonce: string = '';
  signature: string = '';
  firstName: string = '';
  lastName: string = '';
  loading: boolean = false;
  success: boolean = false;
  error: string | null = null;
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    // Get nonce (r) and signature (s) from query parameters
    // Backend generates: /register?r=<nonce>&s=<signature>
    this.route.queryParams.subscribe(params => {
      this.nonce = params['r'] || params['nonce'] || '';
      this.signature = params['s'] || params['signature'] || '';

      if (!this.nonce || !this.signature) {
        this.error = 'Ungültiger Einladungslink. Bitte fordern Sie einen neuen Link an.';
      }
    });
  }

  onSubmit(): void {
    if (!this.firstName || !this.lastName) {
      this.error = 'Bitte füllen Sie alle Pflichtfelder aus.';
      return;
    }

    this.loading = true;
    this.error = null;

    const payload = {
      nonce: this.nonce,
      signature: this.signature,
      firstName: this.firstName,
      lastName: this.lastName
    };

    this.http.post(this.registerEndpoint, payload)
      .subscribe({
        next: (response: any) => {
          this.loading = false;
          this.success = true;
          
          // Redirect to login after 3 seconds
          setTimeout(() => {
            this.router.navigate(['/login']);
          }, 3000);
        },
        error: (err) => {
          this.loading = false;
          console.error('Registration error:', err);
          
          if (err.status === 400) {
            this.error = err.error?.message || 'Ungültige Einladung';
          } else if (err.status === 409) {
            this.error = 'Diese Einladung wurde bereits verwendet';
          } else if (err.status === 410) {
            this.error = 'Diese Einladung ist abgelaufen';
          } else {
            this.error = 'Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.';
          }
        }
      });
  }
}
